import { AssetRiskAndCondition } from '@innovyze/lib_am_common/types/asset.types';
import { InspectionScoredAttributes } from '@innovyze/lib_am_common/types/inspectionAttributes.types';
import { createAction } from '@reduxjs/toolkit';
import { PopupAsset, PopupDetailsParams } from '@Types/popup.types';

export const getPopupDetails =
	createAction<PopupDetailsParams>('/popup/details');
export const getPopupDetailsResolved = createAction('/popup/details/resolved');
export const getPopupDetailsRejected = createAction('/popup/details/rejected');

export const getPopupAsset = createAction<PopupDetailsParams>('/popup/asset');
export const getPopupAssetResolved = createAction<PopupAsset>(
	'/popup/asset/resolved',
);
export const getPopupAssetRejected = createAction('/popup/asset/rejected');

export const getPopupInspections = createAction<string>('/popup/inpsections');
export const getPopupInspectionsClear = createAction(
	'/popup/inpsections/clear',
);
export const getPopupInspectionsResolved = createAction<
	InspectionScoredAttributes[]
>('/popup/inspections/resolved');
export const getPopupInspectionsRejected = createAction(
	'/popup/inpsections/rejected',
);

export const getPopupRisk = createAction<PopupDetailsParams>('/popup/risk');
export const getPopupRiskClear = createAction('/popup/risk/clear');
export const getPopupRiskResolved = createAction<AssetRiskAndCondition>(
	'/popup/risk/resolved',
);
export const getPopupRiskRejected = createAction('/popup/risk/rejected');
